import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Jobs from "@/pages/Jobs";
import Vendors from "@/pages/Vendors";
import VendorDetail from "@/pages/VendorDetail";
import Purchases from "@/pages/Purchases";
import Invoices from "@/pages/Invoices";
import Expenses from "@/pages/Expenses";
import CashAccounts from "@/pages/CashAccounts";
import Reports from "@/pages/Reports";
import Support from "@/pages/Support";
import Settings from "@/pages/Settings";
import Subscription from "@/pages/Subscription";
import AnnualRenewal from "@/pages/AnnualRenewal";
import AdminPricing from "@/pages/admin/AdminPricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentFail from "@/pages/PaymentFail";
import AccountDeleted from "@/pages/AccountDeleted";
import TrialGate from "@/components/TrialGate";
import LifecycleGate from "@/components/LifecycleGate";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminCompanyDetail from "@/pages/admin/AdminCompanyDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";
import AdminProfile from "@/pages/admin/AdminProfile";
import AdminSupport from "@/pages/admin/AdminSupport";
import AdminArchive from "@/pages/admin/AdminArchive";
import AdminDeleted from "@/pages/admin/AdminDeleted";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminRenewalDiagnostics from "@/pages/admin/AdminRenewalDiagnostics";
import { Toaster } from "@/components/ui/sonner";
import MetricaTracker from "@/components/MetricaTracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MetricaTracker />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Login initialMode="register" />} />
            <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
            <Route path="/sifre-sifirla" element={<ResetPassword />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/sifremi-unuttum" element={<AdminForgotPassword />} />
            <Route path="/admin/sifre-sifirla" element={<AdminResetPassword />} />
            {/* Silinme sürecindeki firmalar için özel ekran — Layout DIŞINDA,
                böylece sidebar / navigasyon gösterilmez. ProtectedRoute
                oturum kontrolünü yapar; AccountDeleted içinde ayrıca
                account_status guard'ı vardır. */}
            <Route
              path="/hesap-silinme-surecinde"
              element={
                <ProtectedRoute>
                  <AccountDeleted />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminDashboard />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/companies"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminCompanies />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/companies/:companyId"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminCompanyDetail />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/profile"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminProfile />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/support"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminSupport />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/archive"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminArchive />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/deleted"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminDeleted />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/pricing"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminPricing />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/renewal-diagnostics"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminRenewalDiagnostics />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              path="/admin/audit-log"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminAuditLog />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <LifecycleGate>
                    <Layout />
                  </LifecycleGate>
                </ProtectedRoute>
              }
            >
              {/* Abonelik & ödeme sayfaları — trial gate'ten muaf, herkes
                  (trial, trial_expired, paid, internal_free) erişebilir. */}
              <Route path="/abonelik" element={<Subscription />} />
              <Route path="/abonelik/yenile" element={<AnnualRenewal />} />
              <Route path="/odeme/basarili" element={<PaymentSuccess />} />
              <Route path="/odeme/basarisiz" element={<PaymentFail />} />

              {/* İş modülleri — trial süresi dolan kullanıcılar
                  /abonelik'e yönlendirilir. */}
              <Route element={<TrialGate />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/customers/:id" element={<CustomerDetail />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/vendors" element={<Vendors />} />
                <Route path="/vendors/:id" element={<VendorDetail />} />
                <Route path="/purchases" element={<Purchases />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/cash" element={<CashAccounts />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/support" element={<Support />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
